import React, { useContext, useMemo } from 'react';
import { useQuoteContext } from './quote.js';
import useExchangeErrors from '../hooks/use-exchange-errors.js';
import usePrefilledAmountId from '../hooks/use-prefilled-amount-id.js';
import { useLimitsContext } from './limits.js';
const initialValue = {
    currentError: null,
    preventFromExchanging: false,
};
export const ValidationContext = React.createContext(initialValue);
export const useValidationContext = () => useContext(ValidationContext);
export const ValidationProvider = ({ children }) => {
    const quote = useQuoteContext();
    const limits = useLimitsContext();
    const [prefilledAmountId] = usePrefilledAmountId();
    const { currentError, preventFromExchanging } = useExchangeErrors({
        fee: quote.value?.fee,
        quoteError: quote.error,
        quoteLoading: quote.loading,
        limits: limits.value,
        limitsLoading: limits.loading,
        isSendAll: prefilledAmountId === 'max',
    });
    const contextValue = useMemo(() => ({ currentError, preventFromExchanging }), [currentError, preventFromExchanging]);
    return React.createElement(ValidationContext.Provider, { value: contextValue }, children);
};
